module.exports = __webpack_public_path__ + "img/analysis_subjective_canceltop_white.36c90f13.svg";